import React, { useEffect, useState } from 'react';
import Colors from '../../constants/Colorsv2';
import { ActivityIndicator, FlatList, ScrollView, View } from 'react-native';
import { useDispatch, useSelector } from "react-redux";
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { Icon } from 'react-native-elements';
import { ArticleFeedProps, ArticleProps, PodcastProps, PostProps } from '../../store/types/soc_svc';
import PostCard from '../Social/components/PostCard';
import CarouselNav from './components/CarouselNav';
import { social_getArticles, social_getLiveFeeds, social_getPodcasts, social_getPosts } from '../../store/actionsv1/social';
import { PublicPlayerProps, SmartSearchRequestProps } from '../../store/types/auth_svc';
import { player_getNewPlayers, player_smartSearch } from '../../store/actionsv1/player';
import PlayerCard from '../Social/components/PlayerCard';
import PodcastCard from '../Social/components/PodcastCard';
import LeaderboardCard from './components/LeaderboardCard';
import ArticleCard from '../Social/components/ArticleCard';
import StreamCard from '../Social/components/StreamCard';
import { Image } from 'react-native';
import { AdServer, BEEventApi } from 'be-components';


const DiscoverHomeScreen = ({ navigation }:any) => {
    const [ loading, setLoading ] = useState(true);
    const [ post_loading, setPostLoading ] = useState(false)
    const [ active_post_index, setActivePostIndex ] = useState(0)
    const [ suggested_players_loading, setSuggestedPlayersLoading ] = useState(false)

    const dispatch = useDispatch();
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const stored_players:PublicPlayerProps[] = useSelector((state:any) => state.social.stored_players, (left, right) => left.length === right.length)
    const suggested_players:string[] = useSelector((state:any) => state.social.suggested_players, (left, right) => left.length === right.length)
    const new_players:string[] = useSelector((state:any) => state.social.new_players, (left, right) => left.length === right.length)
    const hot_posts:string[] = useSelector((state:any) => state.social.hot_posts, (left, right) => left.length === right.length)
    const active_post:PostProps | undefined = useSelector((state:any) => state.social.stored_posts.find((sp:PostProps) => sp.memo_post_id == hot_posts[active_post_index]), (left, right) => left?.memo_post_id == right?.memo_post_id)
    const app_size:any = useSelector((state:any) => state.util.app_size, (left, right) => left?.width == right.width)
    const recent_podcasts = useSelector((state:any) => state.social.recent_podcasts, (left, right) => left.length === right.length)
    const stored_podcasts:PodcastProps[] = useSelector((state:any) => state.social.stored_podcasts, (left, right) => left.length === right.length)
    const recent_articles = useSelector((state:any) => state.social.recent_articles, (left, right) => left.length === right.length)
    const stored_articles:ArticleProps[] = useSelector((state:any) => state.social.stored_articles, (left, right) => left.length === right.length)

    const live_feeds_list:{ updated:number, article_feeds:ArticleFeedProps[] } = useSelector((state:any) => state.social.live_feeds_list, (left, right) => left.updated == right.updated)
    const live_feeds = live_feeds_list.article_feeds.filter(f => f.is_live)

    useEffect(() => {
        getPostsFromServer()
        getSuggestedPlayersFromServer()
        getNewPlayersFromServer()
        getPodcastsFromServer()
        setTimeout(() => {
            setLoading(false)
        }, 1500);
    },[])

    const getPodcastsFromServer = async() => {
        await dispatch(social_getPodcasts('suggested', 0))
        await dispatch(social_getArticles('recent', 0))
        await dispatch(social_getLiveFeeds())
    }

    const getPostsFromServer = async() => {
        setPostLoading(true)
        await dispatch(social_getPosts(0, 'hot'))
        setPostLoading(false)
    }
    const getSuggestedPlayersFromServer = async() => {
        setSuggestedPlayersLoading(true)
        const search:SmartSearchRequestProps = {
            player_id: player?.player_id??'0',
            offset: 0,
            region: player?.home_location
        }
        await dispatch(player_smartSearch(search, 'suggested'))
        setSuggestedPlayersLoading(false)
    }

    const getNewPlayersFromServer = async() => {
        await dispatch(player_getNewPlayers(0))
    }

    const renderPlayers = (data: {item:string, index:number}) => {
        if(data.item == player?.player_id){ return <></> }
        const s_player = stored_players.find(sp => sp.player_id == data.item)
        if(!s_player){ return <></> }
        return (
            <View style={{ margin:8, flex:1 }}>
                <PlayerCard width={app_size.width/3} hide_bio vertical player={s_player} viewer_id={player?.player_id??''} onPlayerPress={(p) => navigation.navigate('SocialStack', { screen:  'SocialProfile', initial:false, params: { player_id: p.player_id }})}/>
            </View>
        )
    }

    const renderArticles = (data: {item:string, index:number}) => {
        const article = stored_articles.find(sp => sp.article_id === data.item)
        if(!article){ return <></> }
        return (
            <View style={{ margin: 8 }}>
                <ArticleCard truncate_title maxWidth={app_size.width / 3} width={app_size.width / 3} article={article} onArticlePress={(article) => window.open(article.url, '_blank')}/>
            </View>
        )
    }

    const renderPodcasts = (data: {item:string, index:number}) => {
        const pod = stored_podcasts.find(sp => sp.podcast_id === data.item)
        if(!pod){ return <></> }
        return (
            <View style={{ margin: 8 }}>
                <PodcastCard width={app_size.width / 3} podcast={pod} onPodcastPress={(podcast) => navigation.navigate('SocialStack', { screen:  'PodcastEpisodes', initial:false, params: { podcast_id: podcast.podcast_id }})}/>
            </View>
        )
    }

    const renderLiveFeeds = (data: { item:ArticleFeedProps, index:number }) => {
        if(!data.item.live_stream_url){ return <></> }
        return (
            <StreamCard id={data.item.article_feed_id} width={app_size.width * 0.8} stream_type={data.item.live_stream_type} url={data.item.live_stream_url} />
        )
    }

    if(loading){
        return (
            <View style={{ justifyContent:'center', alignItems:'center', padding:20 }}>
                <ActivityIndicator size='large' color={Colors.brand.midnight} />
            </View>
        )
    }
    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <ScrollView style={{ flex:1, paddingBottom:5 }}>
                {live_feeds.length > 0 ?
                <View nativeID='live_stream'>
                    <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between', padding:16, paddingBottom:0  }}>
                        <Text weight='semibold' color={Colors.brand.midnight} size={16}>Featured Live Streams</Text>
                    </View>
                    <View style={{ padding:16 }}>
                        <FlatList 
                            data={live_feeds} 
                            listKey='live_feeds'
                            renderItem={renderLiveFeeds} 
                            keyExtractor={(item, index) => `${item.article_feed_id}:${index}`} 
                            horizontal
                        /> 
                    </View>
                </View>
                :<></>}
                <TouchableOpacity style={{ margin:15, marginBottom:30 }}
                onPress={() => {
                    navigation.push('Store', {catalog_id: 1})
                }}
                >
                    <Image
                        source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1698695580/BettorEdgeMerch_HatShirt_DiscoverAd_3UP_ezaadj.png' }}
                        style={{ width:app_size.width - 40, height: (app_size.width - 50) / 2.5, alignSelf:'center', marginTop:5 }}
                        resizeMode='cover'
                    />
                    <View style={{ position:'absolute', bottom:-15, left:0, right:0, justifyContent:'center', alignItems:'center'}}>
                        <View style={{ padding:10, backgroundColor:Colors.brand.cyan, borderRadius:8  }}>
                            <Text size={14} color={Colors.shades.white} textAlign='center' weight='bold'>Purchase directly from your wallet</Text>
                        </View>
                    </View>
                </TouchableOpacity>
                {recent_articles.length > 0 ?
                <View nativeID='latest_articles' style={{ backgroundColor:Colors.shades.white }}>
                    <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between', padding:16, paddingBottom:0  }} onPress={() => navigation.navigate('SocialStack', { screen: 'ArticleFeeds', initial:false })}>
                        <Text weight='semibold' color={Colors.brand.midnight} size={16}>Latest Feeds</Text>
                        <Icon name='chevron-right' type='feather' size={18} color={Colors.brand.midnight} />
                    </TouchableOpacity>
                    <View style={{ padding:16 }}>
                        <FlatList listKey='articles' data={recent_articles} renderItem={renderArticles} keyExtractor={(item) => item.toString()} horizontal/>
                    </View>
                </View>
                :<></>}
                {false ?
                <View nativeID='spotlight' style={{ backgroundColor:Colors.shades.shade100  }}>
                    <View style={{ padding:16, paddingBottom:0  }}>
                        <Text weight='semibold' color={Colors.brand.midnight} size={16}>Spotlight</Text>
                    </View>
                    <View style={{ padding:16 }}>
                    </View>
                </View>
                :<></>}
                <AdServer
                    placement='discover_feed'
                    ad_type='discover'
                    onClickAd={(e) => BEEventApi.saveEvent(e)}
                    onViewAd={(e) => BEEventApi.saveEvent(e)}
                />
                {hot_posts.length > 0 ?
                <View nativeID='hot_posts' style={{ backgroundColor:Colors.shades.shade100 }}>
                    <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between', padding:16, paddingBottom:8  }} onPress={() => navigation.navigate('SocialStack', { screen: 'ActivityFeed' })}>
                        <Text weight='semibold' color={Colors.brand.midnight} size={16}>🔥  Hot Posts</Text>
                        <Icon name='chevron-right' type='feather' size={18} color={Colors.brand.midnight} />
                    </TouchableOpacity>
                    {post_loading ?
                    <ActivityIndicator size='large' color={Colors.brand.midnight} />
                    : active_post ?
                    <View>
                        <PostCard view_type='feed' navigation={navigation} post={active_post}/>
                    </View>
                    : <></> }
                    <View style={{ margin:10 }}>
                        <CarouselNav auto_change={false} items={hot_posts} active_index={active_post_index} onIndexSelect={(index) => setActivePostIndex(index)}/>
                    </View>
                </View>
                :<></>}
                {suggested_players.length > 0 ?
                <View nativeID='suggested_players' style={{ backgroundColor:Colors.shades.shade100 }}>
                    <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between', padding:16, paddingBottom:0  }} onPress={() => navigation.push('Search')}>
                        <Text weight='semibold' color={Colors.brand.midnight} size={16}>Suggested Accounts</Text>
                        <Icon name='chevron-right' type='feather' size={18} color={Colors.brand.midnight} />
                    </TouchableOpacity>
                    <View style={{ padding:16 }}>
                        <FlatList listKey='suggested_players' data={suggested_players} renderItem={renderPlayers} keyExtractor={(item) => item.toString()} horizontal showsHorizontalScrollIndicator={false}/>
                    </View>
                </View>
                :<></>}
                {recent_podcasts.length > 0 ?
                <View nativeID='latest_podcasts' style={{ backgroundColor:Colors.shades.white }}>
                    <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between', padding:16, paddingBottom:0  }} onPress={() => navigation.navigate('SocialStack', { screen: 'Podcasts', initial:false })}>
                        <Text weight='semibold' color={Colors.brand.midnight} size={16}>Latest Podcasts</Text>
                        <Icon name='chevron-right' type='feather' size={18} color={Colors.brand.midnight} />
                    </TouchableOpacity>
                    <View style={{ padding:16 }}>
                        <FlatList listKey='podcasts' data={recent_podcasts} renderItem={renderPodcasts} keyExtractor={(item) => item.toString()} horizontal/>
                    </View>
                </View>
                :<></>}
                 {new_players.length > 0 ?
                <View nativeID='new_players' style={{ backgroundColor:Colors.shades.shade100  }}>
                    <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between', padding:16, paddingBottom:0  }} onPress={() => navigation.push('Search')}>
                        <Text weight='semibold' color={Colors.brand.midnight} size={16}>New BE Members</Text>
                        <Icon name='chevron-right' type='feather' size={18} color={Colors.brand.midnight} />
                    </TouchableOpacity>
                    <View style={{ padding:16 }}>
                        <FlatList listKey='players' data={new_players} renderItem={renderPlayers} keyExtractor={(item) => item.toString()} horizontal showsHorizontalScrollIndicator={false}/>
                    </View>
                </View>
                :<></>}
                <View nativeID='top_performers' style={{ backgroundColor:Colors.shades.white, paddingBottom:5 }}>
                    <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between', padding:16, paddingBottom:0  }} onPress={() => navigation.push('Leaderboard', { category_id:'2', timerange_id:'1' })}>
                        <Text weight='semibold' color={Colors.brand.midnight} size={16}>This Weeks Top Performers</Text>
                        <Icon name='chevron-right' type='feather' size={18} color={Colors.brand.midnight} />
                    </TouchableOpacity>
                    <View style={{ marginTop:15 }}>
                        <LeaderboardCard show_limit={3} category_id={'2'} timerange_id={'1'} onLeaderSelect={(leader) => navigation.navigate('SocialStack', { screen:'SocialProfile', initial:false, params: { player_id:leader.player_id } })}/>
                    </View>
                </View>
            </ScrollView>
        </View>
    )
}

export default DiscoverHomeScreen